import Chart from "chart.js/auto";

export default function (areaId, logicalList, knowledgeList, takeDateList) {
	var ctx = document.getElementById(areaId).getContext('2d');
	var logicalBorderColor = 'rgb(24, 240, 99)';

	var logicalBackgroundColor = 'rgba(24, 240, 99, 0.8)';

	var knowledgeBorderColor = 'rgba(255,137,0)';

	var knowledgeBackGroundColor = 'rgba(255,137,0,0.8)';

	var knowledge = knowledgeList;
	//知識データ
	var logical = logicalList;
	//論理データ
	var date = takeDateList;

	//ラベルの色
	Chart.defaults.color = '#fff';

	//日時のデータ（X軸）
	var myAreaChart = new Chart(ctx, {
		type: 'line',
		data: {
			labels: date
			, datasets: [
				{
					label: '論理'
					, data: logical
					, borderColor: logicalBorderColor
					, backgroundColor: logicalBackgroundColor
					, tension: 0
				}
				,
				{
					label: '知識'
					, data: knowledge
					, borderColor: knowledgeBorderColor
					, backgroundColor: knowledgeBackGroundColor
					, tension: 0
				}]
		},
		plugins: [{
			id: 'customVerticalLines',
			afterDatasetsDraw: function (chart, args, options) {
				const { ctx, scales: { x, y } } = chart;
				for (var i = 1; i < date.length - 1; i++) {
					if (date[i] != '') {
						const meta = chart.getDatasetMeta(0);
						const point = meta.data[i];
						if (!point) continue;

						const xPos = point.x;
						const y_top = y.top;
						const y_bottom = y.bottom;

						// 垂直線の描画
						ctx.save();
						ctx.beginPath();
						ctx.lineWidth = 2;
						ctx.strokeStyle = '#FFF';
						ctx.moveTo(xPos, y_top);
						ctx.lineTo(xPos, y_bottom);
						ctx.stroke();
						ctx.restore();
					}
				}
			}
		}],
		options:
		{
			responsive: true,
			maintainAspectRatio: true,
			layout: {
				padding: {
					top: 25,
					bottom: 15,
					left: 10,
					right: 10
				}
			},
			plugins: {
				title: {
					display: true,
					text: '経験値量',
					color: 'white'
				},
				legend: {
					display: true
				}
			},
			scales:
			{
				x: {
					grid: {
						color: "rgba(255,255,255,0.2)"
					},
					ticks: {
						color: "white"
					}
				},
				y: {
					stacked: true,
					min: 0,
					ticks: {
						color: "white",
						stepSize: 0.1,
						autoSkip: false,
						count: 11
					},
					grid: {
						color: "white",
						tickColor: "white"
					}
				}
			}
		}
	});
}